<template>
    <div class="main-page mt-10">
        <div v-if="logoutSplash" class="logout-splash">
         <span>{{ logoutMessage }}</span>
        </div>
        <div class="main-container mt-10">
           <!-- 🔹 Banner Area -->
           <section class="banner-section mb-5">
            <div class="head-title banner-top">
                <h2><i class="fa fa-home text-warning me-2"></i>Featured Rooms</h2>
            </div>

            <template>
            <div class="row">
                <!-- First Slider -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 banner" v-if="list_rooms.length">
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    class="boosted-escorts-banner"
                >
                    <v-carousel-item
                    v-for="(room, i) in firstHalf"
                    :key="`first-${i}`"
                    >
                    <div class="banner-slide text-decoration-none"
                     @click="openRoomModal(room)"
                     style="cursor:pointer;"
                    >
                    <img :src="room.picture" alt="Escort" class="escort-banner-img" />
                    <div class="escort-banner-overlay">
                        <h4>
                        {{ room.title }}
                        </h4>
                        <p>
                        <i class="fa fa-map-marker-alt"></i>
                        {{ room.location }} - {{ formatPrice(room.price) }}
                        </p>
                    </div>
                    </div>
                    </v-carousel-item>
                </v-carousel>
                </div>

                <!-- Second Slider -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 banner d-none d-sm-block" v-if="list_rooms.length">
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    class="boosted-escorts-banner"
                >
                    <v-carousel-item
                    v-for="(room, i) in secondHalf"
                    :key="`second-${i}`"
                    >
                        <div class="banner-slide text-decoration-none"
                         @click="openRoomModal(room)"
                          style="cursor:pointer;"
                        >
                        <img :src="room.picture" alt="Escort" class="escort-banner-img" />
                        <div class="escort-banner-overlay">
                            <h4>
                            {{ room.title }}
                            </h4>
                            <p>
                            <i class="fa fa-map-marker-alt"></i>
                            {{ room.location }} - {{ formatPrice(room.price) }}
                            </p>
                        </div>
                        </div>

                    </v-carousel-item>
                </v-carousel>
                </div>

                <!-- First Slider -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 banner d-none d-sm-block" v-if="list_rooms.length">
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    class="boosted-escorts-banner"
                >
                    <v-carousel-item
                    v-for="(room, i) in firstHalf"
                    :key="`first-${i}`"
                    >
                        <div class="banner-slide text-decoration-none"
                         @click="openRoomModal(room)"
                         style="cursor:pointer;"
                        >
                        <img :src="room.picture" alt="Escort" class="escort-banner-img" />
                        <div class="escort-banner-overlay">
                            <h4>
                            {{ room.title }}
                            </h4>
                            <p>
                            <i class="fa fa-map-marker-alt"></i>
                            {{ room.location }} - {{ formatPrice(room.price) }}
                            </p>
                        </div>
                        </div>
                    </v-carousel-item>
                </v-carousel>
                </div>

                <!-- Second Slider -->
                <div class="col-12 col-sm-6 col-md-6 col-lg-3 banner d-none d-sm-block" v-if="list_rooms.length">
                <v-carousel
                    height="300"
                    cycle
                    hide-delimiters
                    show-arrows-on-hover
                    class="boosted-escorts-banner"
                >
                    <v-carousel-item
                    v-for="(room, i) in secondHalf"
                    :key="`second-${i}`"
                    >
                        <div class="banner-slide text-decoration-none"
                         @click="openRoomModal(room)"
                         style="cursor:pointer;"
                        >
                        <img :src="room.picture" alt="Escort" class="escort-banner-img" />
                        <div class="escort-banner-overlay">
                            <h4>
                            {{ room.title }}
                            </h4>
                            <p>
                            <i class="fa fa-map-marker-alt"></i>
                            {{ room.location }} - {{ formatPrice(room.price) }}
                            </p>
                        </div>
                        </div>
                    </v-carousel-item>
                </v-carousel>
                </div>
            </div>
            </template>

            </section>
            <section id="escort" class="featured-escorts-section mb-5">
            <div class="head-title" @click="searchModels"
            title="Click to show search">
                <h2 class="models-search"> <i class="fa fa-search text-danger me-2"></i>Find Your Perfect Rooms</h2>
            </div>
            <div>
                <transition name="fade-slide">
                <div class="search-menu mb-2"  v-if="showModels">
                     <div class="location">
                        <span>Title</span>
                        <input type="text" name="" id="" class="input-location" v-model="title">
                    </div>

                    <div class="location">
                        <span>Locations</span>
                        <input type="text" name="" id="" class="input-location" v-model="location">
                    </div>
                  
                    <div class="location-range">
                        <div class="range">
                            <span class="age-range">
                                    <p>Price range</p>
                                    <template>
                                        <span class="slider-bg">
                                        <v-range-slider
                                            v-model="value"
                                            min="3000"
                                            max="100000"
                                            thumb-label="always"
                                        ></v-range-slider>
                                        </span>
                                    </template>
                                </span>
                        </div>

                    </div>
                    
                    <div class="btn-filter-cancel">
                        <button class="btn-filter" @click="searchRooms">
                            <span><i class="fa fa-search"></i> Search</span>  
                        </button>
                        &nbsp;
                        <button class="btn-cancel">
                            Cancel
                        </button>
                    </div>
                </div>
                </transition>
            </div>
            </section>

            <hr style="color: #FFF;">
            <!-- Room Listings -->
            <section id="rooms"  class="room-listing-section mb-5">
                <div class="head-title">
                    <h2><i class="fa fa-bed text-primary me-2"></i>Shortlet Rooms</h2>
                </div>

                <!-- Room listings -->
                <div class="row">
                    <div class="col-sm-3" v-for="(room, idx) in list_rooms" :key="idx">
                        <div class="room-card text-dark text-decoration-none"
                          @click="openRoomModal(room)"
                          style="cursor:pointer;"
                        >
                            <img :src="room.picture" alt="Room" class="room-image mb-2" />
                            <h5>{{ room.title }}</h5>
                            <p>{{ room.location }} - {{ formatPrice(room.price) }}</p>
                        </div>
                    </div>
                </div>

                <!-- Modal -->
                <div class="modal fade" id="roomModal" tabindex="-1" aria-labelledby="roomModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">{{ selectedRoom.title }}</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <img :src="selectedRoom.picture" class="img-fluid mb-3 rounded" alt="Room" />
                                <p class="text-muted"><i class="fa fa-map-marker-alt me-1"></i> {{ selectedRoom.location }}  </p>
                                <p><i class="fa fa-eye me-1"></i> <span>Views</span> <span 
                                                                                        style="
                                                                                            display: inline-block;
                                                                                            background: #333; 
                                                                                            color: white; 
                                                                                            width: 30px; 
                                                                                            height: 30px; 
                                                                                            border-radius: 50%; 
                                                                                            text-align: center; 
                                                                                            line-height: 35px; 
                                                                                            font-weight: bold;
                                                                                            margin-right: 6px;
                                                                                        "
                                                                                        >
                                                                                        {{ roomCount }}
                                                                                        </span>
                                                                                       </p>
                                <h5 class="text-success">{{ formatPrice(selectedRoom.price) }}</h5>
                                <p>{{ selectedRoom.description }}</p>
                                <p><i class="fa fa-arrow-down"></i> Book Reservation?</p>
                                <a 
                                    :href="`https://wa.me/${selectedRoom.phone}?text=Hi,%20I'm%20interested%20in%20${encodeURIComponent(selectedRoom.title)}`" 
                                    target="_blank" 
                                    class="btn btn-success"
                                >
                                    <i class="fab fa-whatsapp me-1"></i> Chat on WhatsApp
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
       
        </div>   
       
        <page-loader :is-loading="isLoading"></page-loader>
    </div>
</template>
<script>
//import Vue from 'vue'
import swal from 'sweetalert2';
//import VueCountryDropdown from "vue-country-dropdown";
//import PaystackPop from '@paystack/inline-js';
import PageLoader from '../../components/PageLoader.vue'
import * as bootstrap from 'bootstrap'

//Vue.use(VueCountryDropdown);

export default {
    components: {
        //VueCountryDropdown,     
        PageLoader
    },

data() {
  return {

    pageLoader: false,
    isLoading: false,
    image_path: '',
    find_match: true,
    your_match: false,
    filtering: false,
    filtering2: false,
    nextOption: false,
    chatUser: false,
    viewMatchProfile: false,
    response: '',
    location: '',
    religion: '',
    title: '',
    value: [0, 100],
    user_profile: [],
    profile_pictures: [],
    view_profile: [],
    user_ages: [],
    view_age: '',
    show_profile: [],
    show_age: '',
    options: [],
    match_status: '',
    match_profile: [],
    match_pictures: [],
    match_ages: [],
    show_picture: '',
    valuex: 0,
    is_nigeria: false,
    user_country: '',
    country_dial_code:'',
    country_iso2: '',
    choose_game: false,
    choose_credittype: false,
    user_email: '',
    apikey:'',
    fees: 0,
    regular: 0,
    silver: 0,
    gold: 0,
    package: 0,
    package_name: '',
    list_escorts: [],
    list_rooms: [],
    states: [],
    state: '',

    boostedEscorts: [],
    escortsOnTour: [],
    subscriptionPlans: [],

    faqs: [],
    escort_video: [],
    userId: '',
    logoutSplash: false,
    logoutMessage: "",
    selectedPlan: '',
    selectedFee: '',
    selectedId: '',
    selectedRoom: {},
    showModels: false,
    roomCount: 0
    
  };
},

beforeMount(){
   this.fetchRooms()
   this.getConfigData()
},

mounted(){
    this.user_email = localStorage.getItem("email");
    this.userId = localStorage.getItem("userid"); 
},
computed: {
    firstHalf() {
      const mid = Math.ceil(this.list_rooms.length / 2);
      return this.list_rooms.slice(0, mid);
    },
    secondHalf() {
      const mid = Math.ceil(this.list_rooms.length / 2);
      return this.list_rooms.slice(mid);
    }
  },

methods: {
    async createRoomview(room_id, viewer_id){
        try{

            this.response = await this.$http.post('/create-room-view', {
                room_id: room_id,
              viewer_id: viewer_id
            });
                                
            }catch (err) {
                console.log(err);
        }
    },

    async listRoomview(room_id){
            try{

            const response = await this.$http.get(`/list-room-view/${room_id}`, {

                });
                this.roomCount = response.data.data                 
                }catch (err) {
                    console.log(err);
            }
    },
    searchModels(){
        !this.showModels ? this.showModels = true : this.showModels = false
    },

    async getConfigData(){
        const response = await fetch('/config.json');
        const configData = await response.json();
        this.apikey = configData.apikey;
    },

    formatPrice(price) {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 2
    }).format(price);
  },

    async searchRooms() {
    const minPrice = this.value[0];
    const maxPrice = this.value[1];

    try {
      const response = await this.$http.post('/search-rooms', {
        title: this.title || null,
        location: this.location || null,
        minPrice,
        maxPrice
      });

      this.list_rooms = response.data.data;
    } catch (err) {
        swal.fire({
            icon: "error",
            title: 'Error',
            width:450,
            height:2,
            text: err.response ? err.response.data.message : err.message,
        });
      console.error('Search failed:', err);
    }
    },

    async fetchRooms(){
         try{

            this.response = await this.$http.get('/list-rooms', {
            });

            this.list_rooms = this.response.data.data;
                                  
            }catch (err) {
                swal.fire({
                    title: 'Error',
                    width:250,
                    height:2,
                    text: err.response ? err.response.data.message : err.message,
                });
        }
    },

    async openRoomModal(room) {
        this.selectedRoom = room
        await this.createRoomview(this.selectedRoom.id, this.userId)
        await this.listRoomview(this.selectedRoom.id)
        const modal = new bootstrap.Modal(document.getElementById('roomModal'))
        modal.show()
    }

  }
}

</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');


.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.4s ease-in-out;
  opacity: 0.1;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.logout-splash {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  font-family: 'Raleway';
  font-style: normal;
  background-color: #0A070F; /* green success */
  color: white;
  padding: 15px;
  text-align: center;
  font-weight: bold;
  z-index: 9999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.3);
  transition: top 0.3s ease-in-out;
}

.banner-section{
    background: #111112;
    border-radius: 10px;
}
.banner-top{
    padding: 4px 0 0 4px;
    color: #fff !important;
}
.banner{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.banner-slide {
  position: relative;
  width: 100%;
  height: 100%;
}

.escort-img {
  width: 100%;
  aspect-ratio: 4 / 5;
  object-fit: cover;
  border-radius: 10px;
}

.escort-banner-img {
  width: 100%;
  height: 100%;
  object-fit:cover;
}

.escort-banner-overlay {
  position: absolute;
  bottom: 15px;
  left: 20px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  padding: 10px 15px;
  border-radius: 6px;
}


.main-page {
    padding: 10px 10px 60px 20px;
    width: 100%;
    min-height: 100vh;
}
.main-container{
    width:100%;
}
.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
  }
  
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }
  
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  .btn-outline-primary{
    background: #D33E74;
    color: #fff;
    border: solid 0;
  }
  .btn-outline-primary:hover{
    background: #D33E74;
    color: #333;
  }
  .text-primary{
    text-align: center;
    color: #D33E74 !important;
  }
  .modal-body{
    a{
        text-decoration: none;
        color: #fff;
    }
  }
  .btn-success{
    background: #D33E74;
    border: solid 0px;
   
  }
  .btn-success:hover{
    background: #D33E74;
    color: #fff;
  }
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }
 .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: 520px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
        //background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            font-family: 'DM Sans';
            margin: 4px;

        }

        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            font-family: 'DM Sans';
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
  }
  .modal-masky {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .4s ease;
    & > div {
        //width: 100%;
        height: 200px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        //padding: 2em;
        border: 1px solid #2F2F2F;
        //backdrop-filter: blur(13px);
        background: #19181B;
        border-radius: 20px;
        box-sizing: border-box;
      }
      .profile-view2{
        box-sizing: border-box;
        border-radius: 20px;
        //position:relative;
        width: 100%;
        height: 100%;
       // background: #111112;

        .profile-photo2{
            width: 100%;
            height: auto;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info2 {
    padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio2{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest2{
        
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests2{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }
        .interests-info2 {
            display: flex;
            flex-direction: row;
            //padding: 0rem 3rem 5rem 1rem;
        }
    }
    .profile-relationship-goal2{
        margin-top: -150px !important;
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal2 {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch2 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            cursor: pointer;
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report2 {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
            cursor: pointer;
        }
    }
  }
    .modal-maskp {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;
        
        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .amount {
        display: flex;
        flex-direction: row;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        line-height: 19px;
        color: #FFFFFF;
        justify-content: space-between;
        .fees {
            
        }
        .price {
        
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 27px;
            color: #D33E74;
        }
    }
    .payment-option{
        display: flex; 
        flex-direction: row; 
    }
    .payment-types {
        width: 388px;
        height: 254px;
        background: #272528;
        border-radius: 8px;
        cursor: pointer;
        margin-bottom:20px;
        .payhow{
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 700;
            font-size: 12px;
            line-height: 10px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
            text-align: center;
            margin-top: 10px;
        }
        .payment{
            margin:15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 0px 14px;
            width: 314px;
            height: 46px;
            background: #19181B;
            border-radius: 4px;
            font-family: 'Nunito';
            font-style: normal;
            font-weight: 600;
            font-size: 13px;
            line-height: 22px;
            letter-spacing: -0.02em;
            color: #FFFFFF;
        }

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #0A070F;
        }
        
        
    }
    .player-payinfo{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 13px;
        text-align: center;
        color: #FFFFFF;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        width: 40px;
        background: #333;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        //display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }

    .modal-maskyx {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .4s ease;

        & > div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            //padding: 2em;
            border: 0.5px solid #D33E74;
            background: #19181B;
            border-radius: 20px;
            box-sizing: border-box;
        }
    .player-title{
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 24px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
    }
    .game-mode{
        display: flex; 
        flex-direction: column; 
    }
    .live-mode {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        padding: 10px;
        width: 100%;
        height:50px;
        margin:4px;
        border: 1px solid #D33E74;
        border-radius: 4px;
        margin-right: 20px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 42px;
            text-align: center;
            color: #FFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 13px;
            line-height: 1px;
            text-align: center;
            color: #FFF;
            margin-top: -10px;
        }
        
    }
    .live-mode:hover {
        background: #D33E74;

        P{
            color: #19181B;
        }
        h3{
            color: #19181B;
        }
    }
    .party-mode {
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
        width: 220px;
        height: 180px;
        background: #19181B;
        border: 1px solid #D33E74;
        border-radius: 27px;
        cursor: pointer;

        h3{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        p{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 10px;
            line-height: 12px;
            text-align: center;
            color: #FFFFFF;
            margin-top: -10px;
        }
    }
    .player-name{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 31px;
        text-align: center;
        color: #FFFFFF;

    }
    .player-payinfo{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
        padding: 4px;
        width: 110%;
        height: 30px;
        background: rgba(211, 62, 116, 0.1);
        border-radius: 5px;
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        text-align: center;
        color: #D33E74;
        margin-top: 20px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        margin-bottom:20px


    }
    .player-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px;
        height: auto;
        background: #111112;
        border-radius: 5px;
        font-family: 'Source Sans 3';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 28px;
        color: #FFFFFF;
        margin-top: 10px;
        margin-bottom: 30px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }   
    }
  .modal-xl {
      width: 90%;
     max-width:1200px;
  }
 .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 350px;
      height: 250px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: #19181B;
      border-radius: 20px;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        margin-top: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

  }
  .login-modal-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-top: 10px;
    margin-left: 10px;
    background: #19181B;
    border: 0.5px solid #767475;
    border-radius: 50px;
    //width:500%;
  }
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    margin-left: 10px;
    
}
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
    .tab {
    display: flex;
    flex-direction: row;
    text-align: center;
    width: 100%;

    .find-match {
        margin-top: -10px;
        width: 100%;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;

        p {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
            color: #D33E74;
        }
    }
    .your-matches {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
        color: #767475;
    }

    }
    .find-match:hover {
        margin-top: -10px;
        width: 80px;
        height: 70px;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        border-bottom: 1px solid #D33E74;
        cursor: pointer;
    }
    .your-matches:hover {
        margin-top: -10px;
        border-bottom: 1px solid #D33E74;
        background: #1E1D20;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        cursor: pointer;

        p {
            color: #D33E74;
        }
    }
    .navigation{
        padding: 20px 50px 50px 40px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;

        .elipse{
            float: right;
            margin-left: 90%;
        }
    }
    .photo-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;
        width: 100%;


        .margin{
            margin-top: 10px;
        }
        .overlay-info{
            background: #0a070f76 !important;
        }
        .escort-card {
        transition: transform 0.3s ease;
        background: #fff;
        border-radius: 12px;
        }

        .escort-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        }

        .photo-footer{
            position: absolute;
            padding: 10px 0 0 15px;
            left: 0px;
            bottom: 0px;
            background: #1E1D20;
            opacity: 0.9;
            width: 100%;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            

            h3{
                .username{
                    margin-top: 8px;
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 5px;
                    text-align: left;
                    color: #D33E74;
                }
                .age{
                    margin-top: 8px;
                    font-family: 'DM Sans';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 5px;
                    text-align: left;
                    color: #FFFFFF;
                }
            }
            h6{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 0px;
                text-align: left;
                color: #FFFFFF;
            }
            span{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 0px;
                text-align: left;
                color: #FFFFFF;
            }
        }

        .escort-card-wrapper {
            border-radius: 12px;
            overflow: hidden;
            position: relative;
            transition: transform 0.3s ease;

        h6{
            font-size: 12px;
            font-weight: bold;
        }
        small{
            font-size: 12px;
        }
        }

        .escort-card-wrapper:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
        }


        .featured-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: #ff4081;
        color: white;
        padding: 5px 10px;
        border-radius: 8px;
        font-size: 12px;
        z-index: 10;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
        }

    .verified-icon {
        margin-left: 5px;
        font-size: 16px;
        vertical-align: middle;
    }
    .text-success{
        color: #25D366 !important;
    }
        
    }
   
    .photo {
        //position: absolute;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        border-radius: 20px;
        margin: 0px;
    }
    .profile-view{
        box-sizing: border-box;
        margin-top:30px;
        padding: 0rem 0rem 0rem 0rem;
        width: 120%;
        height: auto;
        background: #111112;

        .profile-photo {
            width: 100%;
            height: 200px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
        }
    }
    .profile-info {
        padding: 1rem 2rem 2rem 1rem;

        h3{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 20px;
            line-height: 24px;
            text-align: left;
            color: #FFFFFF;
            margin-left: 20px;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 10px;
            text-align: left;
            color: #767475;
            margin-left: 20px;
        }
    }
    .profile-bio{
        
        P {
            width: auto;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 154.2%;
            color: #767475;;
            text-align: left;
            margin:20px;
        }

    }
    .profile-interest{
    
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .interests{
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 2px 8px;
            width: auto;
            height: 29px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 50px;
            color: #767475;
            font-size: 10px;
            margin: 4px;

        }

        .interests-info {
            display: flex;
            flex-direction: row;
        }

    }
    .profile-relationship-goal{
        h3 {
            width: auto;
            height: 26px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 20px;
            line-height: 26px;
            text-align: left;
            color: #FFFFFF;
            margin:20px;
        }
        .relationship-goal {
            display: flex;
            flex-direction: row;
            padding: 2px;
            width: 70%;
            height: auto;
            background: rgba(255, 214, 0, 0.1);
            border-radius: 61px;
            color: #FFD600;
            font-size: 10px;
            margin: 20px;
            text-align: left;
        }

    }
    .btn-unmatch-report {
        display: flex;
        flex-direction: row;
        align-items: center;
        .btn-unmatch {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #D33E74;
            margin: 20px;
            
        }
        .btn-unmatch3 {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #111112;
            border: 1px solid #D33E74;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #b1acae;
            margin: 20px;
            cursor: pointer;
        }
        .btn-report {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 55%;
            height: 30px;
            background: #2D2D2D;
            border-radius: 82px;
            font-family: 'Source Sans 3';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 28px;
            color: #767475;
            margin-right: 10px;
        }
    }

    .search-menu {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
       
        .location {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 10px;
            width: 100%;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;

            span {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                text-align: left;
                color: #FFFFFF;
            }
            .input-location {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 10px 17px;
                width: 100%;
                height: 37px;
                background: #1E1D20;
                border: 0.5px solid #767475;
                border-radius: 50px;
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 14px;
                /* identical to box height */
                text-align: center;
                color: #767475;
            }
        }
        .location-range {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 0px;
            width: 380px;
            height: 98px;
            background: #1E1D20;
            border-radius: 11px;
            margin: 4px;
            
            .range {
                display: flex;
                flex-direction: row;
                align-content: space-evenly;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 18px;
                color: #FFFFFF;
                padding: 0px 0 0 0;
                width: 100%;
                
                .men-women {
                    display: flex;
                    flex-direction: row;
                    align-content: space-between;

                    padding: 0rem 2rem 1rem 2rem;

                    .gender-content{
                        display: flex;
                        flex-direction: row;
                        align-content: left;
                        align-items: center;
                        width: 100%;

                        p {
                            margin-left: 0px;
                        }
                        .form-check-input{
                            background: #FFFFFF;
                            height: 20px;
                            width: 20px;

                        }
                        .form-check-input:checked{
                            background: #D33E74;
                            height: 22.5px;
                            width: 22.5px;
                        }
                    }
                    .men{
                        margin: 15px;
                    }
                    
                }
                .age-range {
                    width:100%;
                p {
                    margin-left: 20px;
                }
                .slider-bg{
                    background: #252426;
                    border-radius: 22px;
                }
               }
            }
        }
        .btn-filter-cancel {
            display: grid;
            flex-direction: column;
            margin: 2px;

            .btn-filter{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #FFFFFF;
            }
            .btn-cancel{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 130px;
                height: 35px;
                background: #2F2F2F;
                border-radius: 82px;
                border: 1px solid #D33E74;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 23px;
                color: #D33E74;
            }

        }
    }
    .head-title {
        h2{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 900;
            font-size: 18px;
            line-height: 38px;
            text-align: left;
            color: #D33E74;
            cursor: pointer;
        }

        .models-search{
            color: white !important;
            cursor: pointer;
        }
        .models-search:hover{
            color: #D33E74 !important;
            border-bottom: 0.5px solid #fff; 
            width: 245px;
        }
        
    }
    /* Make image smaller on small screens (mobile) */
    @media (max-width: 576px) {
    .custom-img {
        height: 160px; /* adjust to desired size */
    }
    .escort-img {
        width: 100%;
        aspect-ratio: 3 / 6;
        border-radius: 10px !important;
    }
    }
    @media screen and (max-width: 700px) {
        .banner-section{
            margin-top: 120px;
        }
        .main-page {
            padding: 0px 0px 0px 0px;
        }
        .main-container{
            margin: 0px !important;
            width:100% !important;
        }


        .modal-mask {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
             & > div {
                 width: 80%;
                 height: 520px;
                 position: absolute;
                 top: 50%;
                 left: 50%;
                 transform: translate(-50%, -50%);
                 //padding: 2em;
                 border: 1px solid #2F2F2F;
                 //backdrop-filter: blur(13px);
                 background: #19181B;
                 border-radius: 20px;
                 box-sizing: border-box;
               }
         
               .profile-view2{
                 box-sizing: border-box;
                 border-radius: 20px;
                 //position:relative;
                 width: 100%;
                 height: 100%;
                // background: #111112;
         
                 .profile-photo2{
                     width: 100%;
                     height: auto;
                     background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
                 }
             }
             .profile-info2 {
                  padding: 1rem 2rem 2rem 1rem;
         
                 h3{
                     font-family: 'Raleway';
                     font-style: normal;
                     font-weight: 800;
                     font-size: 20px;
                     line-height: 24px;
                     text-align: left;
                     color: #FFFFFF;
                     margin-left: 20px;
                 }
                 p {
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 10px;
                     text-align: left;
                     color: #767475;
                     margin-left: 20px;
                 }
             }
             .profile-bio2{
                 
                 P {
                     width: auto;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 12px;
                     line-height: 154.2%;
                     color: #767475;;
                     text-align: left;
                     margin:20px;
                 }
         
             }
             .profile-interest2{
                 
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .interests2{
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 2px 8px;
                     width: auto;
                     height: 29px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 50px;
                     color: #767475;
                     font-size: 10px;
                     margin: 4px;
         
                 }
         
                 .interests-info2 {
                     display: flex;
                     flex-direction: row;
                     //padding: 0rem 3rem 5rem 1rem;
                 }
             }
             .profile-relationship-goal2{
                 margin-top: -150px !important;
                 h3 {
                     width: auto;
                     height: 26px;
                     font-family: 'DM Sans';
                     font-style: normal;
                     font-weight: 700;
                     font-size: 20px;
                     line-height: 26px;
                     text-align: left;
                     color: #FFFFFF;
                     margin:20px;
                 }
                 .relationship-goal2 {
                     display: flex;
                     flex-direction: row;
                     padding: 2px;
                     width: 70%;
                     height: auto;
                     background: rgba(255, 214, 0, 0.1);
                     border-radius: 61px;
                     color: #FFD600;
                     font-size: 10px;
                     margin: 20px;
                     text-align: left;
                 }
         
             }
             .btn-unmatch-report2 {
                 display: flex;
                 flex-direction: row;
                 align-items: center;
                 .btn-unmatch2 {
                     box-sizing: border-box;
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #111112;
                     border: 1px solid #D33E74;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #D33E74;
                     margin: 20px;
                 }
                 .btn-report2 {
                     display: flex;
                     flex-direction: row;
                     justify-content: center;
                     align-items: center;
                     padding: 10px;
                     width: 55%;
                     height: 30px;
                     background: #2D2D2D;
                     border-radius: 82px;
                     font-family: 'Source Sans 3';
                     font-style: normal;
                     font-weight: 400;
                     font-size: 13px;
                     line-height: 28px;
                     color: #767475;
                     margin-right: 10px;
                     cursor: pointer;
                 }
             }
        }
        .modal-xl {
              width: 90%;
              max-width:1200px;
        }
        .modal-maskp {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
            
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .amount {
            display: flex;
            flex-direction: row;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 19px;
            color: #FFFFFF;
            justify-content: space-between;
            .fees {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
            }
            .price {
                
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 27px;
                color: #D33E74;
            }
        }
        .payment-option{
            display: flex; 
            flex-direction: row; 
        }
        .payment-types {
            width: 100%;
            height: 254px;
            background: #272528;
            border-radius: 8px;
            cursor: pointer;
            .payhow{
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 700;
                font-size: 12px;
                line-height: 10px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
                text-align: center;
                margin-top: 10px;
            }
            .payment{
                margin:15px;
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 0px 14px;
                width: 90%;
                height: 46px;
                background: #19181B;
                border-radius: 4px;
                font-family: 'Nunito';
                font-style: normal;
                font-weight: 600;
                font-size: 11px;
                line-height: 22px;
                letter-spacing: -0.02em;
                color: #FFFFFF;
            }
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 42px;
                text-align: center;
                color: #0A070F;
            }
            
            
        }
        .player-payinfo{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 11px;
            line-height: 14px;
            text-align: center;
            color: #FFFFFF;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
       
        }

        .modal-maskyx {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .4s ease;
    
            & > div {
                width: 80%;
                height: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                //padding: 2em;
                border: 0.5px solid #D33E74;
                background: #19181B;
                border-radius: 20px;
                box-sizing: border-box;
            }
        .player-title{
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 800;
            font-size: 24px;
            line-height: 42px;
            text-align: center;
            color: #FFFFFF;
        }
        .game-mode{
            display: flex; 
            flex-direction: column; 
        }
        .live-mode {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            align-content: center;
            padding: 10px;
            width: 100%;
            height: 50px;
            background: #D33E74;
            border: 1px solid #D33E74;
            border-radius: 10px;

            cursor: pointer;
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 42px;
                text-align: center;
                color: #0A070F;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 10px;
                line-height: 5px;
                text-align: center;
                color: #0A070F;
                margin-top: -10px;
            }
            
        }
        .live-mode:hover {
            background: #0A070F;
           
            P{
                color: #FFF;
            }
            h3{
                color: #FFF;
            }
        }
        .party-mode {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 10px;
            width: 220px;
            height: 160px;
            background: #19181B;
            border: 1px solid #D33E74;
            border-radius: 27px;
            cursor: pointer;
    
            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 16px;
                line-height: 25px;
                text-align: center;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 10px;
                line-height: 12px;
                text-align: center;
                color: #FFFFFF;
                margin-top: -10px;
            }
        }
        .player-name{
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
            line-height: 31px;
            text-align: center;
            color: #FFFFFF;
    
        }
        .player-payinfo{
            display: flex;
            flex-direction: row;
            justify-content: center;
            //align-items: center;
            align-content: center;
            padding: 4px;
            width: 100%;
            height: 35px;
            background: rgba(211, 62, 116, 0.1);
            border-radius: 5px;
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 14px;
            text-align: center;
            color: #D33E74;
            margin-top: 20px;
            display: block;
            margin-left: auto;
            margin-right: auto;
    
    
        }

        }
        .modal-close-mobile {
            color: #fff;
            line-height: 50px;
            font-size: 140%;
            position: absolute;
            right: 0;
            text-align: center;
            top: 2;
            width: 70px;
            text-decoration: none;
            &:hover {
              color: black;
            }
            display: block;
          }
        .tab {
            display: flex;
            flex-direction: row;
            text-align: center;
            width: 100%;
            padding: 1rem 0rem 0rem 6rem;
        
        
            .find-match {
            margin-top: -10px;
            width: 100%;
            height: 60px;
            background: #1E1D20;
            display: flex;
            flex-direction: columns;
            align-items: center;
            cursor: pointer;
        
            p {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 28px;
                text-align: center;
                color: #D33E74;
            }
            }
            .your-matches {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 28px;
            text-align: center;
            color: #767475;
            cursor: pointer;
            }
        
        }
        .navigation{
            padding: 1rem 2rem 3rem 4rem;
            margin-top: 30px;
            display: flex;
            flex-direction: row;
            
        // align-items: center;
            //justify-content: center;
        
            .elipse{
                float: right;
                margin-left: 90%;
            }
        }
        .photo-row{
           width: 100%;

           .margin {
             //margin: 0px;
           }

           .slider-indicator{
            position: absolute;
            top: 30px;
            left: 50px;
            width: 28px;
            height: 0px;
            border: 1px solid #D33E74;
            transform: rotate(180deg);
        }
        .slider-indicator2{
            position: absolute;
            top: 30px;
            left: 90px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .slider-indicator3{
            position: absolute;
            top: 30px;
            left: 140px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .slider-indicator4{
            position: absolute;
            top: 30px;
            left: 180px;
            width: 28px;
            height: 0px;
            border: 1px solid rgba(182, 182, 182, 0.43);
            transform: rotate(180deg);
        }
        .photo-footer{
            position: absolute;
            padding: 0rem 2rem;
            left: 0%;
            bottom: 0px;
            width: 100%;
            margin-left:0%;
            margin-right: 0%;

            h3{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #FFFFFF;
            }
            p{
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                text-align: left;
                color: #FFFFFF;
            }
        }
        }

        .photo {
            //position: absolute;
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            border-radius: 20px;
            //margin: 1px;
        }
        .profile-view{
            box-sizing: border-box;
            width: 100%;
            height: auto;
            background: #111112;
            margin-left: 75px;
        
            .profile-photo{
                width: 100%;
                height: 250px;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
            }
        }
        .profile-info {
            padding: 1rem 2rem 2rem 1rem;
            
            h3{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 800;
                font-size: 20px;
                line-height: 24px;
                text-align: left;
                color: #FFFFFF;
                margin-left: 20px;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 10px;
                text-align: left;
                color: #767475;
                margin-left: 20px;
            }
        }
        .profile-bio{
            
            P {
                width: auto;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 154.2%;
                color: #767475;;
                text-align: left;
                margin:20px;
            }
        
        }
        .profile-interest{
        
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .interests{
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px 40px;
                width: 83px;
                height: 29px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 50px;
                color: #767475;
                font-size: 12px;
                margin: 4px;
        
            }
            .interests-info {
                display: flex;
                flex-direction: row;
                margin: 20px;
            }
        
        }
        .profile-relationship-goal{
            h3 {
                width: auto;
                height: 26px;
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 700;
                font-size: 20px;
                line-height: 26px;
                text-align: left;
                color: #FFFFFF;
                margin:20px;
            }
            .relationship-goal {
                display: flex;
                flex-direction: row;
                padding: 10px;
                width: 70%;
                height: auto;
                background: rgba(255, 214, 0, 0.1);
                border-radius: 61px;
                color: #FFD600;
                font-size: 12px;
                margin: 20px;
                text-align: left;
            }
        
        }
        .btn-unmatch-report {
            display: flex;
            flex-direction: row;
            align-items: center;
        
        
            .btn-unmatch {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #111112;
                border: 1px solid #D33E74;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #D33E74;
                margin: 20px;
        
                
            }
            .btn-report {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                padding: 10px;
                width: 60%;
                height: 35px;
                background: #2D2D2D;
                border-radius: 82px;
                font-family: 'Source Sans 3';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 28px;
                color: #767475;
                margin-right: 10px;
            }
        }

        .search-menu {
            display: flex;
            flex-direction: column;
            width: 100%;

            .location {
                margin: 4px;
                width: 100%;

                .input-location {
                    width: 100%;
                }
            }

            .location-range {
                width: 100%;
                
                .range {
                    padding: 0rem 0rem 0rem 0rem;

                    .men-women {
                        padding: 0rem 0rem 1rem 0rem;
                        p {
                            margin-left:20px;
                        }
                        .form-check-input{
                            background: #FFFFFF;
                            height: 20px;
                            width: 20px;
                            margin-top: 0px;
                        }
                        .form-check-input:checked{
                            background: #D33E74;
                            height: 22.5px;
                            width: 22.5px;
                        }
                        
                    }
                    .age-range {
                        width:100%;
                    p {
                        margin-left: 20px;
                    }
                    .slider-bg{
                        background: #252426;
                        border-radius: 22px;
                    }
                   }
                }
            }

            .btn-filter-cancel {
                display: flex;
                flex-direction: row;
                padding: 1rem 1rem 1rem 2rem;

                .btn-filter{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #D33E74;
                    border-radius: 82px;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #FFFFFF;
                }
                .btn-cancel{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    padding: 10px;
                    width: 130px;
                    height: 35px;
                    background: #2F2F2F;
                    border-radius: 82px;
                    border: 1px solid #D33E74;
                    font-family: 'Source Sans 3';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 23px;
                    color: #D33E74;
                }
    
            }
        }
        .head-title {
            h2{
                font-family: 'Raleway';
                font-style: normal;
                font-weight: 900;
                font-size: 17px;
                line-height: 38px;
                text-align: left;
                color: #D33E74;
                margin-left: 0px;
            }
            .models-search:hover{
                width: 230px;
            }
        }
    }
    .room-card{
        h5{
            color: #D33E74;
        }
        p{
            color: #CCC;
        }
    }
    .img-fluid{
        border-radius: 12px;
    }

.room-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 6px;
}
.img-fluid{
    transition: 0.3s ease;
}
.img-fluid:hover{
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.room-card {
  background: #fff;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  transition: 0.3s ease;
  margin: 4px;
}
.room-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

.escort-tour-card {
  background-color: transparent;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 5px;
  transition: 0.3s ease;
}

.escort-tour-card:hover {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}
.fw-bold{
    color: #fff;
    small{
        color: #fff !important;
    }
}
.card-header{
    background-color: #fff;
    color: #D33E74;
}

button{
    text-decoration: none;
}
button:hover{
    text-decoration: none;
    color: #D33E74;
}

.escort-tour-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  border-radius: 8px;
}

.video-scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding-bottom: 1rem;
  animation: scroll-left 30s linear infinite;
}

/* Optional: Hide scrollbar */
.video-scroll-container::-webkit-scrollbar {
  display: none;
}
.video-scroll-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Auto scroll animation */
@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.auto-scroll-track {
  animation: scroll-left linear infinite;
  animation-duration: 10s;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}

.escort-video-card {
  min-width: 350px;
  max-width: 350px;
  flex-shrink: 0;
}

.escort-video-card video {
  height: 400px;
  width: 100%;
  object-fit: cover;
}


@media screen and (max-width: 700px) {
.margin-sub {
        margin-top: 10px;
    }
}


 
</style>